import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  onClick: () => void
  label: string
  danger?: boolean
}

export const LinkButton: React.FC<Props> = ({
  onClick,
  label,
  danger = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsJoin(css.link_button, danger && css.danger)}
    >
      {label}
    </button>
  )
}
